import { withInstall } from '@vuesax-plus/utils'
import Sidebar from './src/sidebar.vue'

export const VsSidebar = withInstall(Sidebar)
export default VsSidebar

export * from './src/sidebar'
